/* eslint-disable no-underscore-dangle */
/**
 * @file 基础方法
 */
import copy from 'copy-to-clipboard/index';
import UaUtil from '../utils/uaUtil';
import PlatUtil from '../utils/platUtil';
import Tool from '../utils/tool';
import BdboxInvoke from './bdBoxInvoke';
import HaokanInvoke from './haoKanInvoke';
import CommonApi from '../api/common';
import ClipboardJS from '../utils/clipboard';
import ThunderLog from '../utils/thunder';
import DetectorUtil from '../utils/detectorUtil';
import UrlUtil from '../utils/urlUtil';

export default class {
    constructor(clipboardDomSelector, clipboardText) {
        // 绑定具有复制功能的选择器(可能对应多个对象)，传入具体节点不work，改为传入选择器
        if (clipboardDomSelector && clipboardText) {
            if (!this.clipboardInstanceObj) {
                this.clipboardInstanceObj = new ClipboardJS(clipboardDomSelector);

                // const self = this;
                this.clipboardInstanceObj.on('success', e => {
                    e.clearSelection();
                    console.log('copy success');
                    // 剪切板发送成功日志
                    // self._clipboardLog({status: 1});
                });

                this.clipboardInstanceObj.on('error', () => {
                    console.log('copy error');
                    // 剪切板发送失败日志
                    // self._clipboardLog({ status: 0 });
                });
            }
            // 写入剪切板
            const toClipboardText = `#${clipboardText}#`;
            document.querySelector(clipboardDomSelector).setAttribute('data-clipboard-text', toClipboardText);
        }
    }

    errorUrl = 'https://m.baidu.com'

    // 剪切板实例
    clipboardInstanceObj = null

    clipboardPage = '' // 剪切板日志用

    clipboardPos = '' // 剪切板日志用

    isSendedLogFlagArray = [] // 标记是否发送过剪切板回调日志

    /**
     * 前端拼接吊起应用的ulink（支持好看app）
     *
     * @private
     * @param {string} app app类型
     * @param {Object} opts 拼接ulink时需要的参数,因app而已;
     * @return {string} ulink app的吊起通链。默认返回好看
     */
    _createULinkByApp({app, opts}) {
        const lowApp = app.toLowerCase();
        switch (lowApp) {
            case 'haokan':
                return HaokanInvoke.createHaokanDetailULink({
                    id: opts.id,
                    source: opts.source,
                    failUrl: opts.failUrl
                });
            default:
                return HaokanInvoke.createHaokanDetailULink({
                    id: opts.id,
                    source: opts.source,
                    failUrl: opts.failUrl
                });
        }
    }

    /**
     * 前端拼接吊起scheme, 可直接进行吊起（支持好看app）
     *
     * @private
     * @param {string} app app类型
     * @param {Object} opts 拼接ulink时需要的参数,因app而已;
     * @return {string} scheme app的吊起scheme 。默认返回好看
     */
    _createSchemeByApp({app, opts}) {
        const lowApp = app.toLowerCase();
        switch (lowApp) {
            case 'haokan':
                return HaokanInvoke.createHaokanDetailScheme({
                    id: opts.id,
                    source: opts.source
                });
            default:
                return HaokanInvoke.createHaokanDetailScheme({
                    id: opts.id,
                    source: opts.source
                });
        }
    }

    /**
     * 调起兜底策略
     * 跳转应用市场，appstore，下载apk
     *
     * @private
     * @param {Object} downloadInfo 下载链接
     * @param {string} downloadInfo.ios appStore的下载链接
     * @param {string} downloadInfo.yybao 应用宝下的下载链接
     * @param {string} downloadInfo.pkgurl 安卓apk的下载链接
     * @param {string} downloadInfo.pkgName 安卓apk包名
     * @param {Object} [options] 下载参数
     * @param {Object} [options.isOpenBdAppSearch] 是否用手助下载,默认否
     * @param {Object} [data] 下载数据
     */
    _jump({downloadInfo, options, data}) {
        const self = this;

        if (!Tool.isObject(downloadInfo)) {
            console.warn('If you want to download the app, downloadinfo is required as an object');
            return;
        }

        let canUseBd = PlatUtil.isAndroid() && UaUtil.isBox();

        canUseBd = canUseBd && options && options.isOpenBdAppSearch && downloadInfo.pkgName;

        // 微信，qq跳转应用宝
        if (UaUtil.isWeChat() || UaUtil.isMobileQQ()) {
            setTimeout(() => {
                window.location.href = downloadInfo.yybao || self.errorUrl;
            });
        }
        // ios(非微信，qq)跳转appstore
        else if (PlatUtil.isIos() && !((UaUtil.isWeChat() || UaUtil.isMobileQQ()))) {
            setTimeout(() => {
                window.location.href = downloadInfo.ios || self.errorUrl;
            });
        }
        // 手百相关
        else if (canUseBd) {
            BdboxInvoke.isBdAppSearchInstalled(isInstalled => {
                if (isInstalled) {
                    BdboxInvoke.openBdAppSearch({pkgName: downloadInfo.pkgName});
                }
                else {
                    setTimeout(() => {
                        window.location.href = downloadInfo.yybao || self.errorUrl;
                    });
                }
            });
        }
        /**
         *  安卓(非微信，qq)
         *  如果在手机应用市场名单里，调起应用市场
         *  否则直接下载apk
         */
        else if (PlatUtil.isAndroid() && !UaUtil.isWeChat() && !UaUtil.isMobileQQ()) {
            // 跳转到安卓应用市场（不在支持的应用市场中，下载apk）
            if (downloadInfo.pkgName) {
                self['_goToAndroidAppStore']({
                    downloadInfo,
                    data
                });
                return;
            }

            // 下载apk
            setTimeout(() => {
                window.location.href = downloadInfo.pkgurl || self.errorUrl;
            });
        }
        // 其他，直接下载apk
        else {
            setTimeout(() => {
                window.location.href = downloadInfo.pkgurl || self.errorUrl;
            });
        }
    }

    /**
     * 前端拼接的吊起ulink,scheme（支持手百和好看）
     * data.action.id !==undefined 时,认为是前端自己拼接吊起参数,会进入到该函数逻辑。
     *
     * @private
     * @param {Object} data 吊起相关参数
     * @param {Object} data.action 吊起核心参数。
     * @param {Object} data.id locid
     * @param {Object} data.pagepd 渠道相关信息。统计相关。
     */
    _createInvokeAppULinkAndScheme({action, pagepd, id}) {
        const app = action.app && action.app.toLowerCase();
        let source = {};
        let ulink = '';
        let scheme = '';
        let obj = {};

        if (app === 'bdbox') {
            source = {
                backflow: '1'
            };
            pagepd && pagepd.pagepd && (source.pagepd = pagepd.pagepd) && (source.pagepdSid = pagepd.pagepdSid);
            scheme = BdboxInvoke.createBdboxAppScheme({pagepd, action, source, id});

            obj = {
                app: action.app,
                type: action.type || 'invoke',
                scheme
            };
        }
        else if (app === 'haokan' || !app) {
            source = {
                tab: 'guide'
            };
            pagepd && pagepd.pagepd && (source.tag = pagepd.pagepd) && (source.source = pagepd.source);

            ulink = this['_createULinkByApp']({
                app: action.app,
                opts: {
                    id,
                    failUrl: action.failUrl || '',
                    source
                }
            });
            scheme = this['_createSchemeByApp']({
                app: action.app,
                opts: {
                    id,
                    source
                }
            });
            obj = {
                app: action.app,
                type: action.type || 'invoke',
                ulink,
                scheme
            };
        }

        return obj;
    }

    /**
     * 后端传的吊起信息
     * 当 data.action.id === undefined时,认为是后端传的吊起参数,会进入到该函数逻辑。
     *
     * @private
     * @param {Object} data 吊起相关参数
     * @param {Object} data.action  吊起核心参数。
     * @param {Object} data.downloadInfo 下载信息。
     * @param {Object} data.pagepd 渠道相关信息。统计相关。
     */
    _invokeAppByAppName(data) {
        const {action} = data;
        const {app} = action;
        const appName = app.toLowerCase();

        if (appName === 'channel') { // 手百视频频道
            BdboxInvoke.invokeChannel();
        }
        else if (appName !== 'bdbox') { // 其他app调起
            this['_invokeAppMain'](data);
        }
        else { // 手百
            BdboxInvoke.bdInvoke(data);
        }
    }

    /**
     * 替换scheme上的归因参数tag tag source 和下载链接pkgurl上的渠道包
     * 调起方式为scheme时，需替换schemes上的tag tag source和安卓下载链接pkgurl上的渠道包
     * gpkg gsource gtab gtag 页面上归因参数，对应pkg source tab tag, 因为分享页参数source已被占用，为了不与业务上的tag tag source 弄混，
     * 所以在参数前加g；
     * @private
     * @param {string} link scheme链接
     * @param {string} data.isSupportAttribution 是否需要支持归因统计
     * @param {Object} data.downloadInfo 下载信息。
     * @param {string} data.downloadInfo.pkgurl 安卓下载链接
     */
    _changeSchemeParams(link, data) {
        try {
            // scheme 链接
            let scheme = link;

            if (!scheme || !data.isSupportAttribution) {
                return null;
            }

            // 获取参数
            const pageParams = UrlUtil.getQuery('') || {};
            const schemeParams = UrlUtil.getQuery(scheme) || {};

            const source = pageParams['gsource'] || schemeParams['source'] || '';
            const tab = pageParams['gtab'] || schemeParams['tab'] || '';
            const tag = pageParams['gtag'] || schemeParams['tag'] || '';

            // 替换scheme上的归因参数tab tag souurce
            source && (scheme = UrlUtil.replaceUrlParam(scheme, 'source', source));
            tab && (scheme = UrlUtil.replaceUrlParam(scheme, 'tab', tab));
            tag && (scheme = UrlUtil.replaceUrlParam(scheme, 'tag', tag));

            if (data) {
                // 安卓下载链接
                let pkgUrl = data.downloadInfo && data.downloadInfo.pkgurl;
                const pkgUrlParams = UrlUtil.getQuery(pkgUrl) || {};

                // 获取归因参数pkg source tab tag
                const pkg = pageParams['gpkg'] || pkgUrlParams['channel'] || '';

                // 替换安卓下载链接上的渠道包号
                if (pkgUrl && UrlUtil.getQuery(pkgUrl)['channel']) {
                    pkgUrl = UrlUtil.replaceUrlParam(pkgUrl, 'channel', pkg);
                    data.downloadInfo.pkgurl = pkgUrl;
                }
            }
            return scheme;
        }
        catch (e) {
            // 异常处理，会用没有重新拼接的scheme；
            return null;
        }
    }

    /**
     * 替换applink或者ulink上的归因参数tag tag source 和 target上参数
     * target为安卓下载地址时，替换渠道包
     * target为普通h5链接时，拼接gtag gtab gsource，一步步透传下去
     * gpkg gsource gtab gtag 页面上归因参数，对应pkg source tab tag, 因为分享页参数source已被占用，
     * 为了不与业务上的tag tag source 弄混，所以在参数前加g；
     * @private
     * @param {string} link applink或者ulink
     * @param {string} data.isSupportAttribution 是否需要支持归因统计
     * @param {Object} data.downloadInfo 下载信息。
     * @param {string} data.downloadInfo.pkgurl 安卓下载链接
     */
    _changeLinkParams(link, data) {
        try {
            let linkUrl = link;
            if (!linkUrl || !data.isSupportAttribution) {
                return null;
            }
            // 获取applink ulink上的scheme和target参数
            let scheme = UrlUtil.getQuery(linkUrl)['scheme'];
            let targetUrl = UrlUtil.getQuery(linkUrl)['target'];
            const pkgUrl = data.downloadInfo && data.downloadInfo.pkgurl;

            // 获取参数
            const pageParams = UrlUtil.getQuery('') || {};
            const schemeParams = UrlUtil.getQuery(scheme) || {};
            let pkgUrlParams = {};
            if (pkgUrl) {
                pkgUrlParams = UrlUtil.getQuery(pkgUrl) || {};
            }

            // 获取归因参数pkg source tab tag
            const pkg = pageParams['gpkg'] || pkgUrlParams['channel'] || '';
            const source = pageParams['gsource'] || schemeParams['source'] || '';
            const tab = pageParams['gtab'] || schemeParams['tab'] || '';
            const tag = pageParams['gtag'] || schemeParams['tag'] || '';

            // 替换target上的归因参数
            if (/mvideo\/(quanmin|dl)\?channel=/.test(targetUrl)) {
                // target是安卓下载地址换pkg
                // demo https://quanmin.baidu.com/mvideo/quanmin?channel=xxx
                // demo https://quanmin.baidu.com/mvideo/dl?channel=xxx
                pkg && (targetUrl = UrlUtil.replaceUrlParam(targetUrl, 'channel', pkg));
            }
            else if (/\.apple\.com/.test(targetUrl)) {
                // ios下载地址什么也不做
            }
            else {
                // target是普通h5页面，拼接归因参数gsource, gtab, gtag
                source && (targetUrl = UrlUtil.replaceUrlParam(targetUrl, 'gsource', source));
                tab && (targetUrl = UrlUtil.replaceUrlParam(targetUrl, 'gtab', tab));
                targetUrl && (targetUrl = UrlUtil.replaceUrlParam(targetUrl, 'gtag', tag));
                pkg && (targetUrl = UrlUtil.replaceUrlParam(targetUrl, 'gpkg', pkg));
            }

            // 替换scheme上的归因参数tab tag souurce
            source && (scheme = UrlUtil.replaceUrlParam(scheme, 'source', source));
            tab && (scheme = UrlUtil.replaceUrlParam(scheme, 'tab', tab));
            tag && (scheme = UrlUtil.replaceUrlParam(scheme, 'tag', tag));

            // 重新拼接applink或者ulink
            linkUrl = UrlUtil.replaceUrlParam(linkUrl, 'scheme', encodeURIComponent(scheme));
            linkUrl = UrlUtil.replaceUrlParam(linkUrl, 'target', encodeURIComponent(targetUrl));

            // 返回拼接后的ulink或者applink
            return linkUrl;
        }
        catch (e) {
            // 异常处理，会用没有重新拼接的ulink或者applink
            return null;
        }
    }

    guideMethod() {
        try {
            const imgUrl = PlatUtil.isIos()
                ? 'https://pic.rmb.bdstatic.com/qmpic_APnUVA_1575448478.png'
                : 'https://pic.rmb.bdstatic.com/qmpic_uCa0sU_1575448490.png';
            const div = document.createElement('div');
            div.className = 'rmbgrowthbox-guide-div';
            div.innerHTML = `<img src="${imgUrl}" style="width:100%;" />`;
            div.style.position = 'fixed';
            div.style.top = '0';
            div.style.left = '0';
            div.style.zIndex = '1000';
            div.style.width = '100vw';
            div.style.height = '100vh';
            div.style.textAlign = 'center';
            div.style.backgroundColor = '#000';
            div.style.opacity = '0.82';
            document.body.appendChild(div);
            div.onclick = function () {
                div.remove();
            };
        }
        catch (e) {
            console.error(`weibo guide: ${e}`);
        }
    }

    /**
     * 最核心的吊起机制（非手百APP吊起）
     *
     * @private
     * @param {Object} data 吊起的核心参数
     * @param {Object} data.downloadInfo app下载信息
     * @param {Object} data.action 吊起的核心参数
     * @param {string} data.action.wechat_ckey 微信吊起参数用于统计渠道。
     * @param {string} data.action.scheme 吊起scheme。
     * @param {string} data.action.ulink 吊起universal link。
     * @param {string} data.action.type 值为: invoke 或 normalInvoke。
     * type === 'invoke'时, 安卓下吊起失败会引导下载。
     * type === 'normalInvoke'时,安卓下吊起失败【不会】引导下载
     */
    _invokeAppMain(data) {
        const self = this;
        const action = data.action;
        const timeOut = Number(action.timeOut) ? Number(action.timeOut) : 1500;
        const ckey = action.wechat_ckey;

        if (data.downloadOnly) {
            self['_jump']({
                downloadInfo: data.downloadInfo
            });
            return;
        }

        // 如果是微博，并且不走失败调起逻辑时,且不想禁止微博弹层提示时，展示微博弹层提示
        if (UaUtil.isWeibo() && action.type !== 'normalInvoke' && !data.noneWeiboGuide) {
            this.guideMethod();
        }
        else if (self['_isIOSInvokeAppByUlik'](action)) {// ios ulink调起，兜底策略由ulink 302服务确定
            /**
             * 手百未实现其他app的ulink机制，需要端发版白名单支持
             * ios9以上，手百使用scheme调起，ulink 302做兜底策略
             */
            if (UaUtil.isBox()) {
                // 兼容大搜垂类搜索小视频tab不处理ulink问题
                if (window.location.href.indexOf('/vsearch') === -1) {
                    setTimeout(() => {
                        window.location.href = action.ulink;
                    }, 0);
                }
                window.location.href = action.scheme;
            }
            else {
                window.location.href = self['_changeLinkParams'](action.ulink, data) || action.ulink;
            }
        }
        else if (self['_isAndroidInvokeAppByApplink'](data)) {
            window.location.href = self['_changeLinkParams'](action.appLink, data) || action.appLink;
        }
        // 微信下跳转应用宝，应用宝支持调起(安装调起，未安装从应用宝下载)
        else if (UaUtil.isWeChat() && action.type !== 'normalInvoke') {
            let link = `http://a.app.qq.com/o/simple.jsp?pkgname=${action.pkgName || 'com.baidu.haokan'}${ckey ? `&ckey=${ckey}` : ''}`;
            const useYybApplinkList = ['com.baidu.minivideo', 'com.baidu.mv.drama', 'com.baidu.haokan'];
            if (action.pkgName && useYybApplinkList.includes(action.pkgName)) {
                if (PlatUtil.isIos()) {
                    link = `${link}&ios_scheme=${encodeURIComponent(action.scheme)}`;
                }
                else {
                    link = `${link}&android_scheme=${encodeURIComponent(action.scheme)}`;
                }
            }
            window.location.href = link;
        }
        else { // scheme调起
            let ifr = null;
            const strScheme = action.scheme || action.command;
            if (PlatUtil.isAndroid() && UaUtil.getChromeVersion() > 55) {
                // chrome && version > 55
                window.location.href = self['_changeSchemeParams'](strScheme, data) || strScheme;
            }
            else {
                ifr = document.createElement('iframe');
                ifr.src = self['_changeSchemeParams'](strScheme, data) || strScheme;
                ifr.style.display = 'none';
                document.body.appendChild(ifr);
            }

            /**
             *  调起后兜底策略（无论调起是否成功）
             *  可自定义兜底策略，默认下载apk或者调起appstore
             */
            const lastDate = Date.now();
            let visibilityChangeHideTime = lastDate + 600;

            let hidden;
            let visibilityChange;
            if (typeof document.hidden !== 'undefined') { // Opera 12.10 and Firefox 18 and later support
                hidden = 'hidden';
                visibilityChange = 'visibilitychange';
            }
            else if (typeof document.msHidden !== 'undefined') {
                hidden = 'msHidden';
                visibilityChange = 'msvisibilitychange';
            }
            else if (typeof document.webkitHidden !== 'undefined') {
                hidden = 'webkitHidden';
                visibilityChange = 'webkitvisibilitychange';
            }

            const pageChange = e => {
                // e.type: visibilityChange: 'visibilitychange'  pagehide: 'pagehide'
                if (document[hidden] || e.hidden) {
                    visibilityChangeHideTime = Date.now();
                }
            };

            window.addEventListener('pagehide', pageChange, false);

            document.addEventListener(visibilityChange, pageChange, false);

            document.addEventListener('baiduboxappvisibilitychange', pageChange, false);

            window.setTimeout(() => {
                if (ifr) {
                    document.body.removeChild(ifr);
                }

                if (window.document[hidden]) {
                    return;
                }

                // 立即触发 visibilitychange 表示调起成功
                if ((visibilityChangeHideTime - lastDate) < 600) {
                    return;
                }

                // 返回js上下文的时间超过1秒说明调起成功）
                const now = Date.now();
                const timeDiff = now - lastDate;
                const timeNormal = UaUtil.isBox() ? 300 : timeOut;
                if (timeDiff > timeNormal + 500) {
                    return;
                }

                // 不走调起失败策略
                if (action.type === 'normalInvoke') {
                    return;
                }

                if (action.failCallback && (typeof action.failCallback === 'function')) {
                    action.failCallback();
                }
                else { // 默认调起兜底策略
                    self['_jump']({
                        downloadInfo: data.downloadInfo,
                        options: {
                            // TODO 将 isOpenBdAppSearch 从downloadInfo中移到options中
                            isOpenBdAppSearch: !!(data.downloadInfo && data.downloadInfo.isOpenBdAppSearch)
                        },
                        data: {
                            goToAppStoreLogCb: action.goToAppStoreLogCb
                        }
                    });
                }
            }, UaUtil.isBox() ? 300 : timeOut);
        }
    }

    /**
     * ios下是否使用ulink调起方式
     *
     * @private
     * @param {Object} data 吊起的核心参数
     * @param {Object} data.downloiosGrowthTypeadInfo 调起类型(shceme，growth)
     * @param {Object} data.action 吊起的核心参数
     * @param {string} data.action.scheme 吊起scheme。
     * @param {string} data.action.ulink 吊起universal link。
     * @param {string} data.action.type 值为: invoke 或 normalInvoke。
     * type === 'invoke'时, 安卓下吊起失败会引导下载。
     * type === 'normalInvoke'时,安卓下吊起失败【不会】引导下载
     */
    _isIOSInvokeAppByUlik(action) {
        // ios调起方式：schema，ulink
        const iosGrowthType = action.iosGrowthType || '';

        // 强制配置
        if (iosGrowthType === 'scheme' || iosGrowthType === 'schema') {
            return false;
        }

        // ios9以上使用ulink方式
        if (PlatUtil.isIos9()) {
            return true;
        }
        return false;
    }

    /**
     * 是否使用applink调起方式
     *
     * @private
     * @param {Object} data 吊起的核心参数
     * @param {boolean} data.useAppLink 是否使用applink配置
     * @param {Object} data.forbiddenAppLinkList 禁止使用applink的浏览器名称
     */
    _isAndroidInvokeAppByApplink(data) {
        try {
            let supportAppLink = false;
            const forbiddenAppLinkList = data.forbiddenAppLinkList || [];
            const detector = DetectorUtil.getDetector();
            const version = detector.os.version;
            const browserName = detector.browser.name;
            // 配置使用applink，并且是安卓，并且系统大于等于6
            if (data.useAppLink && data.action.appLink && PlatUtil.isAndroid() && version >= 6) {
                supportAppLink = true;
                // 配置了要支持的浏览器名称
                if (forbiddenAppLinkList instanceof Array && forbiddenAppLinkList.length > 0) {
                    for (let i = 0; i < forbiddenAppLinkList.length; i++) {
                        if (forbiddenAppLinkList[i] === browserName) {
                            supportAppLink = false;
                        }
                    }
                }
            }
            return supportAppLink;
        }
        catch (e) {
            return false;
        }
    }

    /**
     * 安卓下跳转到应用商店或者下载apk
     *
     * @private
     * @param {Object} downloadInfo
     * @param {string} downloadInfo.pkgName 应用商店包地址, eg. com.baidu.haokan
     * @param {Function} [downloadInfo.goToAppStoreLogCb] 日志回调
     * @param {Array}  [downloadInfo.brandList] 数组,需要使用应用商店调起的品牌名称, 为空表示全部, 目前支持 oppo, huawei, xiaomi, samsung, vivo
     * @param {Object} [data] 调起数据
     */
    _goToAndroidAppStore({downloadInfo, data}) {
        const self = this;

        /**
         * 下载apk
         * @param {*} info
         */
        function __gotoDownloadPkg(info) {
            window.location.href = info.pkgurl || self.errorUrl;
        }

        /**
         * 调起指定scheme
         * @param {*} scheme
         */
        function __invoke(scheme) {
            const ifr = document.createElement('iframe');
            ifr.src = scheme;
            ifr.style.display = 'none';
            document.body.appendChild(ifr);
            window.setTimeout(() => {
                document.body.removeChild(ifr);
            }, 300);
        }

        if (!downloadInfo.pkgName || (downloadInfo.brandList && !downloadInfo.brandList.length)) {
            __gotoDownloadPkg(downloadInfo);
        }

        /**
         * 获取匹配的安卓商店对应信息
         */
        const brandInfo = CommonApi.getAndroidStoreBrandInfoByBrandList({
            brandList: downloadInfo.brandList,
            pkgName: downloadInfo.pkgName
        });
        let {storeScheme} = brandInfo;
        const {brand, downloadFirst} = brandInfo;

        // 兜底下载统计
        data && data.goToAppStoreLogCb && data.goToAppStoreLogCb({
            appName: downloadInfo.pkgName,
            brandName: brand || '',
            hitStore: brand === '' ? '0' : '1'
        });

        if (!storeScheme) {
            __gotoDownloadPkg(downloadInfo);
            return;
        }

        if (/tieba/i.test(navigator.userAgent)) {
            // 贴吧调起需要scheme拼接参数
            storeScheme = storeScheme.indexOf('?') > 0
                ? `${storeScheme}&enable_tieba_native_open=1`
                : `${storeScheme}?enable_tieba_native_open=1`;
        }

        // 下载优先
        if (downloadFirst) {
            __gotoDownloadPkg(downloadInfo);
            setTimeout(() => {
                __invoke(storeScheme);
            }, 300);
        }
        else {
            __invoke(storeScheme);
            setTimeout(() => {
                __gotoDownloadPkg(downloadInfo);
            }, 300);
        }
    }

    /**
     * 将调起口令放入剪切板中，方法自动添加格式#口令#
     *
     * @private
     * @param {object} data
     */
    _invokeCommandPutInClipboard({
        clipboardContainer,
        clipboardText,
        clipboardDom,
        clipboardDomSelector,
        elementIndex
    }) {
        // clipboardText && copy('#' + clipboardText + '#');

        /**
         * 需要配置启用复制剪切板的参数
         */
        if (!(clipboardText
            && clipboardDom
            && clipboardDomSelector)
        ) {
            return;
        }

        // 非原生dom
        if (clipboardDom.nodeType !== 1) {
            console.warn('clipboardDom must by HTMLElEMENT');
            return;
        }

        // 剪切板发送日志
        elementIndex && (this.isSendedLogFlagArray[elementIndex] = false);
        if (this.clipboardPage && this.clipboardPos) {
            new ThunderLog().send({
                tid: '10248',
                ct: '17',
                cst: '2',
                logFrom: 'mvapp_h5',
                logInfo: 'performance',
                logExtra: {
                    page: this.clipboardPage,
                    type: 'pasteboard',
                    value: this.clipboardPos,
                    inbox: '0'
                }
            });
        }

        // 绑定具有复制功能的选择器(可能对应多个对象)，传入具体节点不work，改为传入选择器
        if (!this.clipboardInstanceObj) {
            if (clipboardContainer) {
                this.clipboardInstanceObj = new ClipboardJS(clipboardDomSelector, {
                    container: clipboardContainer
                });
            }
            else {
                this.clipboardInstanceObj = new ClipboardJS(clipboardDomSelector);
            }

            const self = this;
            this.clipboardInstanceObj.on('success', e => {
                e.clearSelection();

                const index = e.trigger.getAttribute('data-index');
                // 剪切板发送成功日志
                self['_clipboardLog']({status: 1, index});
            });

            this.clipboardInstanceObj.on('error', e => {
                // 剪切板发送失败日志
                const index = e.trigger.getAttribute('data-index');
                self['_clipboardLog']({status: 0, index});
            });
        }
        const updatedClipboardText = this._changeSchemeParams(clipboardText);
        // 写入剪切板
        const toClipboardText = updatedClipboardText ? `#${updatedClipboardText}#` : `#${clipboardText}#`;
        clipboardDom.setAttribute('data-clipboard-text', toClipboardText);
    }

    /**
     * 【打点】剪切板状态统计打点
     * @param {Number} status 剪切板复制状态
     */
    _clipboardLog({status, index}) {
        if (!(this.clipboardPage && this.clipboardPos)) {
            return;
        }
        if (index && this.isSendedLogFlagArray[index]) {
            return;
        }
        index && (this.isSendedLogFlagArray[index] = true);
        new ThunderLog().send({
            tid: '10248',
            ct: '17',
            cst: '2',
            logFrom: 'mvapp_h5',
            logInfo: 'performance',
            logExtra: {
                page: this.clipboardPage,
                type: 'pasteboard_status',
                value: this.clipboardPos,
                inbox: '0',
                status
            }
        });
    }

    /**
     * 在iframe下吊起。
     * 通过postMessage与外层通信，依赖外层接收通信进行调起策略。主要用于wise_feed视频落地页
     *
     * @public
     * @param {Object} data 吊起的相关参数
     * @param {Object} data.mt 与wise 主feed通信的模块,采用注入形式
     */
    _invokeAppInIframe(data) {
        const {downloadInfo, action, pagepd, mt} = data;
        const {app, ulink, scheme} = action;

        if (!mt) {
            return;
        }

        const postMessage = {
            event: 'videoInvokeApp',
            app: app || 'BdBox',
            action: {}
        };

        if (app === 'BdBox') { // 调起手百通信
            // overwrite,是否强制使用scheme
            const overwrite = '0';

            if (PlatUtil.isAndroid()) {
                postMessage.action = {
                    showTip: false,
                    androidCommand: JSON.stringify(scheme),
                    overwrite
                };

                if (action.type === 'normalInvoke') {
                    mt.addRequestHandle('videoInvokeFail', () => {
                        console.log('videoInvokeFail');
                        action.extra.failCallback && action.extra.failCallback();
                    });
                    postMessage.action.failCallback = '1';
                }
            }
            else {
                postMessage.action = {
                    showTip: false,
                    iosScheme: scheme,
                    overwrite
                };

                if (action.type === 'normalInvoke') {
                    postMessage.action.failUrl = action.extra.failUrl;
                }
            }

            if (pagepd.channel || pagepd.from) {
                postMessage.action.channel = pagepd.channel;
                postMessage.action.from = pagepd.from;
            }
        }
        else { // 调起其他app通信
            postMessage.action = {
                HkUlink: ulink,
                HkScheme: scheme,
                HkDownloadurl: downloadInfo
            };
        }

        // 同主页面通信，发送调起请求
        mt.sendMessage(window.parent, postMessage, false);

        // 发送调起应用商店统计
        (function () {
            const appName = data.action.app;

            if (appName !== 'BdBox'
                && data.action.type !== 'normalInvoke'
                && Tool.isObject(data.downloadInfo)
                && PlatUtil.isAndroid()
                && !UaUtil.isWeChat()
                && !UaUtil.isMobileQQ()
                && data.downloadInfo.pkgName
            ) {
                const {brandList, pkgName} = data.downloadInfo;

                const brandInfo = CommonApi.getAndroidStoreBrandInfoByBrandList({
                    brandList,
                    pkgName
                });

                data && data.action && data.action.goToAppStoreLogCb && data.action.goToAppStoreLogCb({
                    appName: pkgName,
                    brandName: brandInfo.brand || '',
                    hitStore: brandInfo.brand === '' ? '0' : '1'
                });
            }
        })();
    }

    /**
     * 是否支持剪切板以及生成弹框功能
     *
     * @public
     * @param {Object} data 吊起的相关参数
     * @param {Object} data.failCopy 是否需要支持复制失败弹框提示功能
     * @param {Object} data.failCopy.shortToken 短口令，如果不传，默认读action.scheme
     * @param {Object} data.popbgImage 弹框背景图片，如果不传，用默认图片
     */
    _isSupportexecCommand(data) {
        // create Dom
        const failCopy = data.failCopy || {};
        const poptoken = document.createElement('textarea');
        poptoken.id = 'rmbgrowthboxpoptoken';
        poptoken.setAttribute('readonly', 'readonly');
        poptoken.setAttribute('style', 'position: absolute;left: -9999px;top: 39px; margin: 0 auto');
        document.body.appendChild(poptoken);
        poptoken.value = failCopy.shortToken || data.action.scheme;
        let clipflag = false;
        try {
            poptoken.select();
            poptoken.setSelectionRange(0, poptoken.value.length);
            clipflag = document.execCommand('copy');
        }
        catch (e) {
            console.log(e.description);
        }
        if (!clipflag) {
            window.rmbgrowthboxcloseBtn = () => {
                document.getElementById('rmbgrowthboxerrorClipboard').style.display = 'none';
            };
            if (document.getElementById('rmbgrowthboxpoplayerbox')) {
                document.getElementById('rmbgrowthboxcode').innerText = failCopy.shortToken || (`#${data.action.scheme}#`);
                document.getElementById('rmbgrowthboxpopbgbox').style.height = `${(document.body.offsetHeight || window.innerHeight)}px`;
                document.getElementById('rmbgrowthboxerrorClipboard').style.display = 'block';
            }
            else {
                const oPop = document.createElement('div');
                oPop.id = 'rmbgrowthboxerrorClipboard';
                oPop.setAttribute('class', 'pop');
                const stylePopbg = 'background:rgba(0,0,0,.5);width:100%;height:100%;top:0;left:0;position:absolute;';
                const stylePopbox = 'width:240px;height:250px;margin:auto;position:absolute;left:0;right:0;top:0;bottom:0;background-repeat:no-repeat;background-position:center; background-size: 100% auto;';
                const styleCode = 'background-color:rgba(255,255,255,0);width:78%;word-wrap:break-word;height:74px;overflow-y:scroll;display:block;color:#c12525;padding:0;font-family:none;font-size:14px;line-height:19px;text-align:left;word-break:break-all;margin:92px 11% 83px;';
                const styleClosebtn = 'width:29px;height:29px;border-radius:50%;border:1px solid #fff3cb;font-weight:200;color:#fff3cb;font-size:24px;text-align:center;margin:40px auto 0;line-height:1.1;';
                oPop.innerHTML = [
                    '<div id="rmbgrowthboxpopbgbox"></div>',
                    '<div id="rmbgrowthboxpoplayerbox">',
                    `<div id="rmbgrowthboxcode">${failCopy.shortToken || data.action.scheme}</div>`,
                    '<div id="rmbgrowthboxclosebtn" onclick="rmbgrowthboxcloseBtn()">×</div>',
                    '</div>'
                ].join('');
                document.body.appendChild(oPop);
                const popbgbox = document.getElementById('rmbgrowthboxpopbgbox');
                const poplayerbox = document.getElementById('rmbgrowthboxpoplayerbox');
                const code = document.getElementById('rmbgrowthboxcode');
                const closebtn = document.getElementById('rmbgrowthboxclosebtn');
                popbgbox.setAttribute('style', stylePopbg);
                poplayerbox.setAttribute('style', stylePopbox);
                code.setAttribute('style', styleCode);
                closebtn.setAttribute('style', styleClosebtn);
                const popbgImage = failCopy.popbgImage || 'https://imgsa.baidu.com/normandy/pic/item/b21bb051f81986185bce4b8a44ed2e738bd4e637.jpg';
                poplayerbox.style.backgroundImage = `url(${popbgImage})`;
            }
            return false;
        }
        return true;
    }

    /**
     * 总处理函数
     *
     * @public
     * @param {Object} data 吊起的相关参数
     * @param {string} data.onceEveryDay 一天是否只吊起一次。如果需求一天只吊起一次,则为该字段赋值,值为localstorage的key.
     */
    go(data) {
        if (!Tool.isObject(data) || !Tool.isObject(data.action)) {
            console.warn('Object is required for invokeApp.go');
            return;
        }

        /**
         * 每天调起一次的策略，参数为localstore key
         */
        if (data.onceEveryDay) {
            const needInvoke = CommonApi.onceEveryDay(data.onceEveryDay);
            if (!needInvoke) {
                return;
            }
        }

        // 有每日最大调起次数的限制
        if (data.invokeCntPerDay) {
            const needInvoke1 = CommonApi.invokeCntPerDay(data.invokeCntPerDay);
            if (!needInvoke1) {
                return;
            }
        }

        // 发送日志
        data.logFn && data.logFn();
        this.clipboardPage = (data.clipboard && data.clipboard.clipboardPage) || '';
        this.clipboardPos = (data.clipboard && data.clipboard.clipboardPos) || '';

        /**
         * 口令写入剪切板中，用于调起端后，供端识别
         * 口令格式 #xxxxx#
         */
        const {action, pagepd} = data;
        let app = action && action.app;
        app = app.toLowerCase();

        // 判断传进来的scheme是否是对象,为好看导流平台特异化处理
        if (Tool.isObject(action.scheme)) {
            const schemeOptions = action.scheme;
            action.scheme = `bdminivideo://webview?params=${encodeURIComponent(JSON.stringify(schemeOptions.params))}&tab=${schemeOptions.tab}&tag=${schemeOptions.tag}&source=${schemeOptions.source}`;
        }
        // 判断传进来的ulink是否是对象,为好看导流平台特异化处理
        if (Tool.isObject(action.ulink)) {
            const ulinkOptions = action.ulink;
            action.ulink = `https://vv.baidu.com/feedvideoui/ulink?scheme=${encodeURIComponent(action.scheme)}&target=${encodeURIComponent(ulinkOptions.target)}`;
        }

        // 是否需要支持手动复制
        if (data.failCopy && data.failCopy.isSupportManualCopy) {
            if (!(this._isSupportexecCommand(data))) {
                return;
            }
        }

        this._invokeCommandPutInClipboard({
            clipboardContainer: (data.clipboard && data.clipboard.clipboardContainer),
            clipboardText: (data.clipboard && data.clipboard.clipboardText),
            clipboardDom: (data.clipboard && data.clipboard.clipboardDom),
            clipboardDomSelector: (data.clipboard && data.clipboard.clipboardDomSelector),
            elementIndex: (data.clipboard && data.clipboard.elementIndex)
        });

        /**
         *  区分调起信息是前端拼接，还是直接传入
         */
        const {id, isSelfHandle, copyValue} = data.action;
        // 调起库增加是否开启剪切板字段
        if (copyValue) {
            copy(copyValue);
        }

        if (id && (app === 'bdbox' || isSelfHandle)) { // 手百由前端自己拼接吊起相关链接
            const obj = this._createInvokeAppULinkAndScheme({
                action,
                pagepd,
                id
            });
            data.action = Tool.mergeObject(action, obj);
        }

        /**
         *  调起及其兜底策略
         */
        if (window.self !== window.top) { // 调起触发在iframe内（wise feed落地页）调起逻辑
            this._invokeAppInIframe(data);
        }
        else { // 正常落地页调起
            this._invokeAppByAppName(data);
        }
    }
}
